import { BrowserModule } from '@angular/platform-browser';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxScrollbarAppModule } from 'src/app/shared/modules/ngx-scrollbar-app/ngx-scrollbar-app.module';
import { ScrollbarManager } from 'ngx-scrollbar';
import { SmoothScrollManager } from 'ngx-scrollbar/smooth-scroll';
import { ToastrModule } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { ResourceEmailModule } from 'src/app/shared/modules/resource-email/rsource-email.module';
import { ConfirmationModalModule } from 'src/app/shared/modules/confirmation-modal/confirmation-modal.module';
import { PlaybookViewerModule } from './playbook-viewer/playbook-viewer.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { OnlineSwitchModule } from 'src/app/shared/modules/online-switch/online-switch.module';
import { OfflineVideoComponent } from './playbook-viewer/shared/components/offline-video/offline-video.component';
import { SendIframeUrlService } from 'src/app/shared/services/send-iframe-url/send-iframe-url.service';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

@NgModule({ declarations: [
        AppComponent,
        OfflineVideoComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        OnlineSwitchModule,
        ReactiveFormsModule,
        ModalModule,
        ResourceEmailModule,
        ConfirmationModalModule,
        BrowserAnimationsModule,
        NgxScrollbarAppModule,
        PopoverModule,
        RichTextEditorComponent,
        ToastrModule.forRoot({})], providers: [{
            provide: 'BASE_URL',
            useFactory: getBaseUrl
        },
        LocalStorageService,
        SmoothScrollManager,
        ScrollbarManager, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }

@NgModule({ declarations: [],
    bootstrap: [], imports: [BrowserModule,
        AppRoutingModule,
        PlaybookViewerModule,
        FormsModule,
        OnlineSwitchModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgxScrollbarAppModule,
        PopoverModule,
        RichTextEditorComponent,
        ToastrModule.forRoot({})], providers: [{
            provide: 'BASE_URL',
            useFactory: getBaseUrl
        },
        LocalStorageService,
        SendIframeUrlService,
        SmoothScrollManager,
        ScrollbarManager, provideHttpClient(withInterceptorsFromDi()),] })
export class AppMainModule { }

@NgModule({})
export class AppViewerSharedModule {
  static forRoot(): ModuleWithProviders<AppMainModule> {
    return {
      ngModule: AppMainModule,
      providers: []
    };
  }
}
